import React, { useState } from "react";
import api from "../utils/api";
import { toast } from "react-toastify";

export default function UploadCSV({ onUpload }) {
  const [file, setFile] = useState(null);

  const handleUpload = async () => {
    if (!file) return toast.error("Select a CSV file first");
    const formData = new FormData();
    formData.append("file", file);

    try {
      await api.post("/transactions/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("CSV uploaded successfully");
      setFile(null);
      onUpload();
    } catch (err) {
      toast.error(err.response?.data?.message || "Upload failed");
    }
  };

  return (
    <div className="mt-3">
      <input
        type="file"
        accept=".csv"
        onChange={(e) => {
          setFile(e.target.files[0]);
        }}
      />
      <button className="btn btn-primary mx-2" onClick={handleUpload}>
        Upload CSV
      </button>
    </div>
  );
}
